import { Alert, Stack, Text } from "@mantine/core";
import { IconSparkles } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import { JOB_INSIGHT_TYPE_LABELS } from "../../constants/recruiterAi";
import { jobsApi } from "../../lib/api";
import { HtmlContent } from "../ui";

const BASED_ON_LABEL = "Based on";
const PAST_SUBMISSIONS_LABEL = "past submissions";
const SPARKLE_SIZE = "var(--axio-unit-16)";

export type JobInsightAlertItem = {
  id: string;
  insight_type: string;
  content: string;
  based_on_count?: number | null;
};

export function JobInsightAlerts({ insights }: { insights: JobInsightAlertItem[] }) {
  if (insights.length === 0) return null;

  return (
    <Stack gap="md">
      {insights.map((insight) => (
        <Alert
          key={insight.id}
          color="yellow"
          variant="light"
          icon={<IconSparkles size={SPARKLE_SIZE} />}
          title={JOB_INSIGHT_TYPE_LABELS[insight.insight_type] ?? insight.insight_type}
        >
          <HtmlContent html={insight.content} />
          {insight.based_on_count != null && insight.based_on_count > 0 ? (
            <Text size="xs" c="dimmed" mt="md">
              {BASED_ON_LABEL} {insight.based_on_count} {PAST_SUBMISSIONS_LABEL}
            </Text>
          ) : null}
        </Alert>
      ))}
    </Stack>
  );
}

export function JobInsightsBanner({ jobId }: { jobId: string }) {
  const query = useQuery({
    queryKey: ["job-insights", jobId],
    queryFn: () => jobsApi.insights(jobId),
    enabled: !!jobId,
  });
  return <JobInsightAlerts insights={query.data ?? []} />;
}
